<template>
  <div>
        <banner>
            <div class="huoyuanxx">
                <div style="font-size:36px;">关于我们</div>
                <div style="margin-top:18px;font-size:18px;line-height:28px;">了解我们的企业宗旨、企业文化，为您提供更好的服务</div>
            </div>
        </banner>
        <div class="shidata">
            <div class="sstit">
                <div class="dabt">公司概括</div>
                <div v-html="wzinfor.basicSurvey"></div>
            </div>
        </div>
        <div style="background:#f5f7f6;">
            <div class="shidata" style="background:#f5f7f6;">
                <div class="lianxwm" style="margin-top:0;">
                    <div class="dabt">公司文化</div>
                    <div>
                        <p>创新与进步只为给您带来卓越体验</p>
                        <p>理念:以人为本、服务至上</p>
                        <p>精神:优质、诚信、尊重、快捷</p>
                        <p>方针:拓展、提高、灵活、多维</p>                                                         
                    </div>
                </div>
            </div>
        </div>
        <div style="padding:80px 0;background:#6d9fc7;text-align:center;color:#fff;">
            <div style="padding-bottom:20px;font-size:24px;">我们的承诺</div>
            <div>
                <p>创新、诚信，与开发者共同成长，向全球最大物流服务平台的目标迈进</p>                                                       
            </div>
        </div>
  </div>
</template>

<script>
import Banner from '../components/banner/banner'
import { mapState } from 'vuex'
export default {
    data(){
        return {
           wzinfor:{}
        }
    },
    components:{
        Banner
    },
    computed:{
        ...mapState(['infor'])
    },
    methods:{
       
    },
    watch:{
        infor(){
            this.wzinfor = this.infor
        }
    },
    created(){
        this.wzinfor = this.infor   // this.$store.state.infor
    }
}
</script>

<style lang="stylus" scoped>
    .huoyuanxx
        padding-top: 80px
        color: #fff
    .shidata
        width: 1000px
        margin: 0 auto
        padding: 70px
        background: #fff
        line-height: 24px
        word-break: break-all
        .sstit
            text-align: center
        .dabt
            margin-bottom: 15px
            font-size: 24px
            color: #08599A
            font-weight: bold
        .lianxwm
            margin-top: 90px
            text-align: center
            .lxwmnr
                font-size: 16px
                text-align:center
                div
                    margin-top: 15px
                    span
                         font-weight: bold               

</style>